const TermsAndConditions = () => {
  return <>TermsAndConditions</>;
};

export default TermsAndConditions;
